export default __webpack_public_path__ + "static/media/Right-Arrow.d9f4f24e.svg";